import { TokenPoints } from "@bentolabs/points-worker";

import { Header } from "./header";
import { Row } from "./row";

type Props = {
  pools: TokenPoints[];
  className?: string;
};

export const Pools = ({ className, pools }: Props) => {
  return (
    <section className={className}>
      <h2 className="mb-7 text-2xl">Pools</h2>
      <Header className="mb-3.5" />
      <div className="flex flex-col gap-1.5 overflow-hidden rounded-[20px]">
        {pools.map((pool) => {
          return <Row pool={pool} />;
        })}
      </div>
    </section>
  );
};
